export const currentLanguageId = (state = 2, action) => {
  switch (action.type) {
    case 'SET_LANGUAGE_ID':
      return action.data;
    default:
      return state;
  }
};

export const currentUiLanguageId = (state = 2, action) => {
  switch (action.type) {
    case 'SET_UI_LANGUAGE_ID':
      return action.data;
    default:
      return state;
  }
};

export const currentDeliveryType = (state = null, action) => {
  switch (action.type) {
    case 'SET_DELIVERY_TYPE':
      return action.data;
    default:
      return state;
  }
};

export const currentTableId = (state = null, action) => {
  switch (action.type) {
    case 'SET_TABLE_ID':
      return action.data;
    default:
      return state;
  }
};

export const orderTips = (state = null, action) => {
  switch (action.type) {
    case 'SET_ORDER_TIPS':
      return action.data;
    default:
      return state;
  }
};

export const orderGuidCode = (state = null, action) => {
  switch (action.type) {
    case 'SET_ORDER_GUID_CODE':
      return action.data;
    default:
      return state;
  }
};

export const branchMessageShown = (state = false, action) => {
  switch (action.type) {
    case 'SET_BRANCH_MESSAGE_SHOWN':
      return action.data;
    default:
      return state;
  }
};

export const generalErrorTranslationKey = (state = null, action) => {
  switch (action.type) {
    case 'SET_GENERAL_ERROR_TRANSLATION_KEY':
      return action.data;
    default:
      return state;
  }
};
